// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OneToOneOutlinedSvg from "@ant-design/icons-svg/es/asn/OneToOneOutlined";
import AntdIcon from '../components/AntdIcon';

var OneToOneOutlined = function OneToOneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: OneToOneOutlinedSvg
  }));
};

OneToOneOutlined.displayName = 'OneToOneOutlined';
export default /*#__PURE__*/React.forwardRef(OneToOneOutlined);